import { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    SelectField,
    EditButton,
    ReferenceOneField
} from 'react-admin';
import { complianceSnifferTypes } from "../../defaults/defaults";
import { MiniResultStatusField } from "./components/MiniResultStatusField";

export const ComplianceSnifferResultsList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <SelectField source="type" choices={ complianceSnifferTypes } />
                { /* A result whose scoring gave up is why this column exists. In a plain text
                     column it looked like every other row, which defeats the point of moving it
                     out of 'scoring' in the first place. */ }
                <MiniResultStatusField label="Status" />
                <EditButton label="View" />
            </Datagrid>
        </List>
    );
}
